'use client'

import { useEffect, useState } from 'react'
import { ATTRIBUTION_KEYS, type Attribution } from '@/lib/lead-tracking'
import { getStoredAttribution } from '@/lib/lead-tracking-client'

/**
 * Hidden inputs with the stored campaign data (gclid, gbraid, wbraid, utm_*) and the service slug,
 * so GTM / form scrapers see them. Forms also send the same values in their JSON payload.
 */
export default function AttributionHiddenFields({ servicio }: { servicio: string }) {
  const [attribution, setAttribution] = useState<Attribution>({})

  useEffect(() => {
    setAttribution(getStoredAttribution())
  }, [])

  return (
    <>
      <input type="hidden" name="servicio" value={servicio} />
      {ATTRIBUTION_KEYS.map((key) => (
        <input key={key} type="hidden" name={key} value={attribution[key] ?? ''} />
      ))}
    </>
  )
}
